import React, { Fragment, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { MainTitle, SubTitle } from "../styled/WelcomeMsg.styled";

export default function Title({ emboss }) {
  const [userDetails, setUserDetails] = useState({});
  useEffect(() => {
    setUserDetails(user);
  }, []);
  const user = JSON.parse(localStorage.getItem("user"));
  return (
    <Fragment>
      <Grid container spacing={0} justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <MainTitle emboss={emboss}>Welcome, {userDetails?.name} </MainTitle>
        </Grid>
        <Grid item xs={12}>
          <SubTitle emboss={emboss}>Data and Analytics can bring science to your decisions</SubTitle>
        </Grid>
      </Grid>
    </Fragment>
  );
}

Title.propTypes = {
  mainTitleColor: PropTypes.oneOf(["#006F35", "#FFFF"]),
  subTitleColor: PropTypes.oneOf(["#006F35", "#FFFF"]),
};

Title.defaultPops = {
  mainTitleColor: "#006F35",
  subTitleColor: "#FFFF",
};